import React, { useState, useEffect } from "react";
import { productService } from "../../services/productService";
import toast from "react-hot-toast";

const InventoryManagement = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await productService.getProducts();
      setProducts(response.data);
    } catch (error) {
      toast.error("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  const handleStockUpdate = async (id, newStock) => {
    try {
      await productService.updateStock(id, { stock: newStock });
      toast.success("Stock updated successfully");
      fetchProducts();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update stock");
    }
  };

  const getStockStatus = (stock) => {
    if (stock <= 0) return { text: "Out of Stock", color: "red" };
    if (stock <= 5) return { text: "Low Stock", color: "orange" };
    return { text: "In Stock", color: "green" };
  };

  const getStatusBadgeClasses = (color) => {
    switch (color) {
      case "red":
        return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300";
      case "orange":
        return "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300";
      default:
        return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300";
    }
  };

  if (loading) {
    return <div className="text-center py-20">Loading...</div>;
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Inventory Management</h1>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b dark:border-gray-700">
                <th className="text-left p-3">Product</th>
                <th className="text-left p-3">Brand</th>
                <th className="text-left p-3">Current Stock</th>
                <th className="text-left p-3">Status</th>
                <th className="text-left p-3">Update Stock</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => {
                const stockStatus = getStockStatus(product.inventory?.stock);
                return (
                  <tr
                    key={product._id}
                    className="border-b dark:border-gray-700"
                  >
                    <td className="p-3">{product.name}</td>
                    <td className="p-3">{product.brand?.name}</td>
                    <td className="p-3 font-semibold">
                      {product.inventory?.stock}
                    </td>
                    <td className="p-3">
                      <span
                        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusBadgeClasses(stockStatus.color)}`}
                      >
                        {stockStatus.text}
                      </span>
                    </td>
                    <td className="p-3">
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          defaultValue={product.inventory?.stock}
                          className="w-20 px-2 py-1 border rounded dark:bg-gray-700"
                          id={`stock-${product._id}`}
                        />
                        <button
                          onClick={() => {
                            const input = document.getElementById(
                              `stock-${product._id}`,
                            );
                            handleStockUpdate(
                              product._id,
                              parseInt(input.value),
                            );
                          }}
                          className="btn-primary px-3 py-1 text-sm"
                        >
                          Update
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InventoryManagement;
